/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExportGipReportQueryResponse, AuditReportsExportGipReportPathParams, AuditReportsExportGipReportQueryParams, AuditReportsExportGipReport400, AuditReportsExportGipReport401, AuditReportsExportGipReport403, AuditReportsExportGipReport404 } from "../models/AuditReportsExportGipReport";

export function getAuditReportsExportGipReportUrl(id: AuditReportsExportGipReportPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/report/${id}/export` as const }
  return res
}

/**
 * @summary Export existing report
 * {@link /audit-reports/v1/reports/gip/report/:id/export}
 */
export async function auditReportsExportGipReport(id: AuditReportsExportGipReportPathParams["id"], params: AuditReportsExportGipReportQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsExportGipReportQueryResponse, ResponseErrorConfig<AuditReportsExportGipReport400 | AuditReportsExportGipReport401 | AuditReportsExportGipReport403 | AuditReportsExportGipReport404>, unknown>({ method : "GET", url : getAuditReportsExportGipReportUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}